
var frequency = {};

frequency.ONCE = 1;
frequency.MONTHLY = 2;
frequency.BIMONTHLY = 3;
frequency.QUARTERLY = 4;
frequency.SEMIYEARLY = 5;
frequency.WEEKLY = 10;
frequency.BIWEEKLY = 12;
frequency.FIRSTFIFTEEN = 15;
frequency.FIFTEENLAST = 16;
frequency.YEARLY = 20;
frequency.TWOYEAR = 21;
frequency.THREEYEAR = 22;
frequency.FOURYEAR = 23;
frequency.FIVEYEAR = 24;


frequency.types = [
  { code: frequency.MONTHLY, longCode: "Monthly", desc: "Monthly" },
  { code: frequency.BIMONTHLY, longCode: "Bimonthly", desc: "Bi Monthly" },
  { code: frequency.QUARTERLY, longCode: "Quarterly", desc: "Quarterly" },
  { code: frequency.SEMIYEARLY, longCode: "Semiyearly", desc: "Semi Yearly" },

  { code: frequency.WEEKLY, longCode: "Weekly", desc: "Weekly" },
  { code: frequency.BIWEEKLY, longCode: "BiWeekly", desc: "Bi Weekly" },

  { code: frequency.FIRSTFIFTEEN, longCode: "FirstAndFifteen", desc: "First and Fifteenth" },
  { code: frequency.FIFTEENLAST, longCode: "FifteenAndLast", desc: "Fifteenth and Last" },
  
  { code: frequency.ONCE, longCode: "Once", desc: "Once" },

  { code: frequency.YEARLY, longCode: "Yearly", desc: "Yearly" },
  { code: frequency.TWOYEAR, longCode: "TwoYear", desc: "Two Years" },
  { code: frequency.THREEYEAR, longCode: "ThreeYear", desc: "Three Years" },
  { code: frequency.FOURYEAR, longCode: "FourYear", desc: "Four Years" },
  { code: frequency.FIVEYEAR, longCode: "FiveYear", desc: "Five Years" },
];


frequency.getFrequencies = function() {
  return this.types;
}


frequency.getFreqAsConst = function( freq ) {
  var f = this.types.find( i => i.longCode === freq );
  if ( f === undefined ) {
    return this.MONTHLY;
  }

  return f.code;
}


frequency.ConvertFrequency = function (freq) {
  var val = 'XX';

  switch (freq) {
    case 'Monthly':
      val = 'MN';
      break;
    case 'Weekly':
      val = 'WK';
      break;
    case 'BiWeekly':
      val = 'BW';
      break;
    case 'FirstAndFifteen':
      val = 'FF';
      break;
    case 'FifteenAndLast':
      val = 'FL';
      break;
    case 'Yearly':
      val = 'YR';
      break;
    case 'TwoYear':
      val = '2Y';
      break;
    case 'ThreeYear':
      val = '3Y';
      break;
    case 'FourYear':
      val = '4Y';
      break;
    case 'FiveYear':
      val = '5Y';
      break;
    case 'Once':
      val = 'ON';
      break;
    default:
      val = 'XX';
  }

  return val;
}


/**
 * Given a Date and a frequency enum return the next date
 * @param {Date} date 
 * @param {numeric} freq 
 */
frequency.getNextDate = function( date, freq ) {
  var next_date = new Date( date );

  switch ( freq )
  {
    case frequency.MONTHLY:
      next_date.setMonth( date.getMonth() + 1 );
      break;
    case frequency.BIWEEKLY:
      next_date.setDate( date.getDate() + 14 );
      break;
    case frequency.WEEKLY:
      next_date.setDate( date.getDate() + 7 );
      break;
    case frequency.BIMONTHLY:
      next_date.setMonth( date.getMonth() + 2 );
      break;
    case frequency.FIFTEENLAST:
      next_date = frequency.fifteenAndLast( date );
      break;

    case frequency.QUARTERLY:
      next_date.setMonth( date.getMonth() + 3 );
      break;
    case frequency.SEMIYEARLY:
      next_date.setMonth( date.getMonth() + 6 );
      break;
    //case "FirstAndFifteen":
    //    next_date = FirstAndFifteen( date );
    //  break;
    case frequency.YEARLY:
      next_date.setFullYear( date.getFullYear() + 1 );
      break;
    case frequency.TWOYEAR:
      next_date.setFullYear( date.getFullYear() + 2 );
      break;
    case frequency.THREEYEAR:
        next_date.setFullYear( date.getFullYear() + 3 );
      break;
    case frequency.FOURYEAR:
      next_date.setFullYear( date.getFullYear() + 4 );
      break;
    case frequency.FIVEYEAR:
      next_date.setFullYear( date.getFullYear() + 5 );
      break;
    default:
      next_date.setMonth( date.getMonth() + 1 );
  } // switch freq

  return next_date;
}


// See C# Core.Engine.DataGenerator.NextDate

/**
 * Given a real date and a frequency, return the next date that is greater
 * than or equal to todays date.
 * @param {Date} date
 * @param {number} freq
 * @param {string} targetDate
 * @returns {Date}
 */
frequency.getNextDateAfterDate = function( startDate, freq, targetDate ) {
  var next_date = new Date( startDate );

  while ( next_date < targetDate ) {
    next_date = frequency.getNextDate( next_date, freq );
  }

  return next_date;
}


frequency.fifteenAndLast = function( date ) {
  var next_date = new Date( date );

  var year = date.getFullYear();
  var month = date.getMonth();
  var day = date.getDate();

  var days_in_month = new Date(year, month+1, 0).getDate();

  if ( day < 15 ) {
    next_date.setDate( 15 );
  }
  else if ( day >= 15 && day < days_in_month ) {
    next_date.setDate( days_in_month );
  }
  else {
    next_date.setMonth(month+1, 15 );
  }

  return next_date;
}


export default frequency;

